import React, { useContext } from "react";
import { Box, Center, Group, Image, Text, Divider, Anchor } from "@mantine/core";
import VXLogo from "../assets/vx-logo.svg";
import { DataContext } from "../context/DataContext";

export default function AppFooter() {
  const { text, data, settings } = useContext(DataContext);
  if (settings?.isFooterShown === false) return null;

  return (
    <Box
      align="center"
      style={{
        position: "absolute",
        bottom: 15,
        width: "100%",
        align: "center",
        zIndex: 10000,
      }}
    >
      <Center>
        <Group spacing={10}>
          <Group spacing={5}>
            <Image src={VXLogo} width={20} />
            <Text fz="xs" c="dimmed">
              {text.general.poweredBy} Veratad
            </Text>
          </Group>
          <Divider orientation="vertical" />
          <Anchor
            href={
              data?.settings?.journey?.settings?.privacyPolicy ||
              "https://veratad.com/privacy-policy/"
            }
            size="xs"
            target="_blank"
          >
            {text.general.privacyPolicy}
          </Anchor>
        </Group>
      </Center>
    </Box>
  );
}
